module.exports = __webpack_public_path__ + "img/main-title.681c1dc8.png";